import { useTranslation } from 'react-i18next';
import { useDashboardDaysStore } from 'src/models/useDashboardDaysModel';

import DashboardLayout from '../../Layout/DashboardLayout';
import TimeRangeSelector from '../../TimeRangeSelector';
import RansomwareDetections from './RansomwareDetections';
import RansomwareTop5Domains from './RansomwareTop5Domains';
import RansomwareTop5Files from './RansomwareTop5Files';
import RansomwareTop5Senders from './RansomwareTop5Senders';
import { DashboardPeriod } from '@Types/dashboard';
import { useExpandSection } from '../useExpandSection';

export default function Ransomware() {
  const { t } = useTranslation();
  const daysModel = useDashboardDaysStore();
  const { data, isExpanded, isLoading, onExpandChange, isError, refetch } =
    useExpandSection({
      section: 'ransomware',
      period: daysModel.days.DashboardRansomware as DashboardPeriod,
    });

  return (
    <DashboardLayout
      title={t('dashboard.sideBar.ransomware')}
      titleBar={<TimeRangeSelector widgetId="DashboardRansomware" />}
      barColor="#A04242"
      expanded={isExpanded}
      onExpandChange={onExpandChange}
      loading={isLoading}
      loadingFailed={isError}
      onRetryLoading={refetch}
    >
      <RansomwareDetections
        data={data}
        day={daysModel.days['DashboardRansomware']}
      />
      <RansomwareTop5Senders
        data={data}
        day={daysModel.days['DashboardRansomware']}
      />
      <RansomwareTop5Files
        data={data}
        day={daysModel.days['DashboardRansomware']}
      />
      <RansomwareTop5Domains
        data={data}
        day={daysModel.days['DashboardRansomware']}
      />
    </DashboardLayout>
  );
}
